/**
 * @see https://github.com/justinribeiro/lite-youtube
 */
import '@justinribeiro/lite-youtube';

/*
let youTubeIframeAPILoaded = false;

declare global
{
	const YT: any;
}
 */


document.addEventListener( 'liteYoutubeIframeLoaded', e =>
{
	if (e.target instanceof HTMLElement) {

		const video = e.target.closest( '.video' );

		if (video instanceof HTMLElement) {
			video.classList.add( 'iframe-loaded' );
		}
	}

	/*
		if (e.target instanceof HTMLElement && e.target.shadowRoot instanceof ShadowRoot) {

		const iframe = e.target.shadowRoot.querySelector( 'iframe' );

		if (iframe instanceof HTMLIFrameElement) {

			loadYouTubeIframeAPI().then( () =>
			{
				const player = new YT.Player( iframe, {
					events: {
						//'onReady': onPlayerReady,
						//'onStateChange': onPlayerStateChange
					}
				} );
			} );

				}
			}
	 */
} );


/**
 * @see https://developers.google.com/youtube/iframe_api_reference
 */

/*
const loadYouTubeIframeAPI = () =>
{
	return new Promise( resolve =>
	{
		if (youTubeIframeAPILoaded) {
			resolve( null );
			return;
		}

		const script = document.createElement( 'script' );

		script.src = 'https://www.youtube.com/iframe_api';

		document.head.insertAdjacentElement( 'beforeend', script );

		(window as any).onYouTubeIframeAPIReady = () =>
		{
			youTubeIframeAPILoaded = true;
			resolve( null );
		};
	} );
};

 */